import React from 'react'
import { FormCheck, FormDone, FormFail, Pay3D } from './DefaultTemplate'
import { FormGNSInitial } from './GNSTemplate'
import { FORM } from '@pay24/common/src/store/PaymentStore'
import { PaymentStore } from '@pay24/common/src/store'
import { Input } from '../Input'
import Spacer from '../Spacer'
import { observer } from 'mobx-react'
import * as yup from 'yup'

const FormGNSTransportInitial = observer((props) => {
  const { service, source } = props
  const { payData } = PaymentStore

  const valid_fields = {
    vehicle_number: yup.string().required('Введите номер автомобиля'),
  }

  const renderFields = (options_errors) => {
    const fields = service.data && service.data.fields
    if (!fields || fields.length === 0 || Object.keys(fields).length === 0) {
      return null
    }

    const vehicle_number = fields.find(
      (value) => value.name === 'vehicle_number',
    )

    return (
      <>
        <Input
          testID="vehicle_number_text"
          errorText={options_errors?.vehicle_number}
          label={vehicle_number.label}
          value={payData.getOptions(vehicle_number.name)}
          onChangeText={(val) => {
            PaymentStore.payData.setOptions(vehicle_number.name, val)
          }}
        />
        <Spacer />
      </>
    )
  }

  return (
    <FormGNSInitial
      {...props}
      source={source}
      customFields={renderFields}
      gns_valid_fields={valid_fields}
    />
  )
})

export default (isAgent) => {
  if (isAgent) {
    return {
      steps: 3,
      [FORM.INITIAL]: FormGNSTransportInitial,
      [FORM.CHECK]: FormCheck,
      [FORM.PAID]: FormDone,
      [FORM.FAIL]: FormFail,
    }
  }
  return {
    steps: 4,
    [FORM.INITIAL]: FormGNSTransportInitial,
    [FORM.CHECK]: FormCheck,
    [FORM.PAYMENT_3D]: Pay3D,
    [FORM.PAID]: FormDone,
    [FORM.FAIL]: FormFail,
  }
}
